import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectJobServiceCreateResponseJson } from '@vmspdb/definitions';
import * as fromProjectJobs from './project-jobs.reducer';

export const selectProjectJobstate =
  createFeatureSelector<fromProjectJobs.State>(
    fromProjectJobs.projectJobsFeatureKey,
  );

export const selectAllProjectJobs = createSelector(
  selectProjectJobstate,
  (state) => state.jobs,
);

export const selectAllProjectJobsWithDetailsProto = createSelector(
  selectAllProjectJobs,
  (state): ProjectJobServiceCreateResponseJson[] => state,
);

export const selectProjectHasJobs = createSelector(
  selectProjectJobstate,
  (state) => state.jobs.length > 0,
);

export const selectProjectHasNoValidJobs = createSelector(
  selectProjectJobstate,
  (state) =>
    state.jobs.length === 0 || state.jobs.some((job) => job?.flags?.inProgress),
);
export const selectProjectJobsLoading = createSelector(
  selectProjectJobstate,
  (state) => state.loading,
);
